<div class="farachat-layout w-full h-full min-h-full max-h-full overflow-hidden flex flex-col">
  <div class="header-container flex-none w-full min-h-16 max-h-16">
    <app-header />
  </div>
  <div class="flex-1 w-full h-full overflow-y-auto">
    <main class="farachat-main w-full h-full">
      <router-outlet></router-outlet>
    </main>
  </div>
</div>
